// extracted by mini-css-extract-plugin
export var codeBlock = "typography-module--codeBlock--PR5gR";
export var codeHeading = "typography-module--codeHeading--Yg3Xq";
export var error = "typography-module--error--56gAb";
export var h1 = "typography-module--h1--qjW1z";
export var h5 = "typography-module--h5--H6M7+";
export var heading = "typography-module--heading--AdW8T";
export var headingWithTopMargin = "typography-module--headingWithTopMargin--u9yDD";
export var homeParagraph = "typography-module--homeParagraph--fc-KW";
export var note = "typography-module--note--cVmyF";
export var questionTitle = "typography-module--questionTitle--mEgBJ";
export var rulesTitle = "typography-module--rulesTitle--jOv4S";
export var subHeading = "typography-module--subHeading--mpfqn";
export var subTitle = "typography-module--subTitle---JIAC";
export var title = "typography-module--title--BXcb5";
export var typeText = "typography-module--typeText--q5Z2M";
export var videoLink = "typography-module--videoLink--GsnE+";